export default "__VITE_ASSET__CKo0tHPl__"